// TODO: delete?
export const handleQueryInputChange = async (
  configuredInputs,
  defaultInputConfigurations,
  updateSelectedInput,
  updatedInputUri,
  uri
) => {
  const inputConfig = getInputConfig(
    configuredInputs,
    defaultInputConfigurations,
    updatedInputUri
  )

  await updateSelectedInput(uri, updatedInputUri, inputConfig)
}

export const getInputConfig = (
  configuredInputs,
  defaultInputConfigurations,
  updatedInputUri
) => {
  const updatedSignalConfig = configuredInputs[updatedInputUri] || {}

  const { inputConfig } = updatedSignalConfig

  if (!inputConfig) {
    return defaultInputConfigurations[updatedInputUri]
  }

  return inputConfig
}
